import { defineComponent as _defineComponent } from 'vue'
import { useFacetsStore } from '#imports'
import { computed } from 'vue'
import { PuSearchLinkProps } from '../../../pu-links/link-search/PuSearchLinkProps'


export default /*#__PURE__*/_defineComponent({
  __name: 'LowResultsFacets',
  props: {
    facetSlugs: null
  },
  setup(__props: any) {

const props = __props as {
  facetSlugs: string[]
};


const facetsStore = useFacetsStore()

const facets = computed(() =>
  props.facetSlugs
    .map((slug) => facetsStore.facetsBySlug[slug])
    .filter((facet) => facet)
    .sort((a, b) => a.name.localeCompare(b.name)),
)

const searchLinkPropsWithoutAllFacets = computed<PuSearchLinkProps>(() => {
  return {
    facet: '',
    modifyFilters: {
      facets: [],
    },
  }
})

function getSearchLinkPropsWithoutFacet(slug: string): PuSearchLinkProps {
  const newFacets = props.facetSlugs.filter((f) => f !== slug)
  return {
    facet: '',
    modifyFilters: { facets: newFacets },
  }
}

return { __sfc: true,props, facetsStore, facets, searchLinkPropsWithoutAllFacets, getSearchLinkPropsWithoutFacet }
}

})